import {g as vt} from '@theme/_commonjsHelpers';
var L = {exports: {}},
  k = {exports: {}},
  A = {exports: {}},
  gt = A.exports,
  $;
function G() {
  return (
    $ ||
      (($ = 1),
      (function (m) {
        (function (l, h) {
          m.exports ? (m.exports = h()) : (l.EvEmitter = h());
        })(typeof window < 'u' ? window : gt, function () {
          function l() {}
          var h = l.prototype;
          return (
            (h.on = function (d, a) {
              if (!(!d || !a)) {
                var s = (this._events = this._events || {}),
                  n = (s[d] = s[d] || []);
                return n.indexOf(a) == -1 && n.push(a), this;
              }
            }),
            (h.once = function (d, a) {
              if (!(!d || !a)) {
                this.on(d, a);
                var s = (this._onceEvents = this._onceEvents || {}),
                  n = (s[d] = s[d] || {});
                return (n[a] = !0), this;
              }
            }),
            (h.off = function (d, a) {
              var s = this._events && this._events[d];
              if (!(!s || !s.length)) {
                var n = s.indexOf(a);
                return n != -1 && s.splice(n, 1), this;
              }
            }),
            (h.emitEvent = function (d, a) {
              var s = this._events && this._events[d];
              if (!(!s || !s.length)) {
                (s = s.slice(0)), (a = a || []);
                for (var n = this._onceEvents && this._onceEvents[d], o = 0; o < s.length; o++) {
                  var t = s[o],
                    e = n && n[t];
                  e && (this.off(d, t), delete n[t]), t.apply(this, a);
                }
                return this;
              }
            }),
            (h.allOff = function () {
              delete this._events, delete this._onceEvents;
            }),
            l
          );
        });
      })(A)),
    A.exports
  );
}
var I = {exports: {}};
/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */ var Z;
function pt() {
  return (
    Z ||
      ((Z = 1),
      (function (m) {
        (function (l, h) {
          m.exports ? (m.exports = h()) : (l.getSize = h());
        })(window, function () {
          function h(f) {
            var S = parseFloat(f),
              v = f.indexOf('%') == -1 && !isNaN(S);
            return v && S;
          }
          function d() {}
          var a =
              typeof console > 'u'
                ? d
                : function (f) {
                    console.error(f);
                  },
            s = [
              'paddingLeft',
              'paddingRight',
              'paddingTop',
              'paddingBottom',
              'marginLeft',
              'marginRight',
              'marginTop',
              'marginBottom',
              'borderLeftWidth',
              'borderRightWidth',
              'borderTopWidth',
              'borderBottomWidth',
            ],
            n = s.length;
          function o() {
            for (
              var f = {width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0}, S = 0;
              S < n;
              S++
            ) {
              var v = s[S];
              f[v] = 0;
            }
            return f;
          }
          function t(f) {
            var S = getComputedStyle(f);
            return (
              S ||
                a(
                  'Style returned ' +
                    S +
                    '. Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1'
                ),
              S
            );
          }
          var e = !1,
            r;
          function c() {
            if (!e) {
              e = !0;
              var f = document.createElement('div');
              (f.style.width = '200px'),
                (f.style.padding = '1px 2px 3px 4px'),
                (f.style.borderStyle = 'solid'),
                (f.style.borderWidth = '1px 2px 3px 4px'),
                (f.style.boxSizing = 'border-box');
              var S = document.body || document.documentElement;
              S.appendChild(f);
              var v = t(f);
              (r = Math.round(h(v.width)) == 200), (g.isBoxSizeOuter = r), S.removeChild(f);
            }
          }
          function g(f) {
            if (
              (c(),
              typeof f == 'string' && (f = document.querySelector(f)),
              !(!f || typeof f != 'object' || !f.nodeType))
            ) {
              var S = t(f);
              if (S.display == 'none') return o();
              var v = {};
              (v.width = f.offsetWidth), (v.height = f.offsetHeight);
              for (var p = (v.isBorderBox = S.boxSizing == 'border-box'), D = 0; D < n; D++) {
                var i = s[D],
                  u = S[i],
                  y = parseFloat(u);
                v[i] = isNaN(y) ? 0 : y;
              }
              var x = v.paddingLeft + v.paddingRight,
                E = v.paddingTop + v.paddingBottom,
                b = v.marginLeft + v.marginRight,
                C = v.marginTop + v.marginBottom,
                P = v.borderLeftWidth + v.borderRightWidth,
                Y = v.borderTopWidth + v.borderBottomWidth,
                j = p && r,
                Q = h(S.width);
              Q !== !1 && (v.width = Q + (j ? 0 : x + P));
              var J = h(S.height);
              return (
                J !== !1 && (v.height = J + (j ? 0 : E + Y)),
                (v.innerWidth = v.width - (x + P)),
                (v.innerHeight = v.height - (E + Y)),
                (v.outerWidth = v.width + b),
                (v.outerHeight = v.height + C),
                v
              );
            }
          }
          return g;
        });
      })(I)),
    I.exports
  );
}
var M = {exports: {}},
  T = {exports: {}},
  K;
function mt() {
  return (
    K ||
      ((K = 1),
      (function (m) {
        (function (l, h) {
          m.exports ? (m.exports = h()) : (l.matchesSelector = h());
        })(window, function () {
          var h = (function () {
            var d = window.Element.prototype;
            if (d.matches) return 'matches';
            if (d.matchesSelector) return 'matchesSelector';
            for (var a = ['webkit', 'moz', 'ms', 'o'], s = 0; s < a.length; s++) {
              var n = a[s],
                o = n + 'MatchesSelector';
              if (d[o]) return o;
            }
          })();
          return function (a, s) {
            return a[h](s);
          };
        });
      })(T)),
    T.exports
  );
}
var tt;
function _() {
  return (
    tt ||
      ((tt = 1),
      (function (m) {
        (function (l, h) {
          m.exports ? (m.exports = h(l, mt())) : (l.fizzyUIUtils = h(l, l.matchesSelector));
        })(window, function (h, d) {
          var a = {};
          (a.extend = function (o, t) {
            for (var e in t) o[e] = t[e];
            return o;
          }),
            (a.modulo = function (o, t) {
              return ((o % t) + t) % t;
            });
          var s = Array.prototype.slice;
          (a.makeArray = function (o) {
            if (Array.isArray(o)) return o;
            if (o == null) return [];
            var t = typeof o == 'object' && typeof o.length == 'number';
            return t ? s.call(o) : [o];
          }),
            (a.removeFrom = function (o, t) {
              var e = o.indexOf(t);
              e != -1 && o.splice(e, 1);
            }),
            (a.getParent = function (o, t) {
              for (; o.parentNode && o != document.body; ) if (((o = o.parentNode), d(o, t))) return o;
            }),
            (a.getQueryElement = function (o) {
              return typeof o == 'string' ? document.querySelector(o) : o;
            }),
            (a.handleEvent = function (o) {
              var t = 'on' + o.type;
              this[t] && this[t](o);
            }),
            (a.filterFindElements = function (o, t) {
              o = a.makeArray(o);
              var e = [];
              return (
                o.forEach(function (r) {
                  if (r instanceof HTMLElement) {
                    if (!t) {
                      e.push(r);
                      return;
                    }
                    d(r, t) && e.push(r);
                    for (var c = r.querySelectorAll(t), g = 0; g < c.length; g++) e.push(c[g]);
                  }
                }),
                e
              );
            }),
            (a.debounceMethod = function (o, t, e) {
              e = e || 100;
              var r = o.prototype[t],
                c = t + 'Timeout';
              o.prototype[t] = function () {
                var g = this[c];
                clearTimeout(g);
                var f = arguments,
                  S = this;
                this[c] = setTimeout(function () {
                  r.apply(S, f), delete S[c];
                }, e);
              };
            }),
            (a.docReady = function (o) {
              var t = document.readyState;
              t == 'complete' || t == 'interactive' ? setTimeout(o) : document.addEventListener('DOMContentLoaded', o);
            }),
            (a.toDashed = function (o) {
              return o
                .replace(/(.)([A-Z])/g, function (t, e, r) {
                  return e + '-' + r;
                })
                .toLowerCase();
            });
          var n = h.console;
          return (
            (a.htmlInit = function (o, t) {
              a.docReady(function () {
                var e = a.toDashed(t),
                  r = 'data-' + e,
                  c = document.querySelectorAll('[' + r + ']'),
                  g = document.querySelectorAll('.js-' + e),
                  f = a.makeArray(c).concat(a.makeArray(g)),
                  S = r + '-options',
                  v = h.jQuery;
                f.forEach(function (p) {
                  var D = p.getAttribute(r) || p.getAttribute(S),
                    i;
                  try {
                    i = D && JSON.parse(D);
                  } catch (y) {
                    n && n.error('Error parsing ' + r + ' on ' + p.className + ': ' + y);
                    return;
                  }
                  var u = new o(p, i);
                  v && v.data(p, t, u);
                });
              });
            }),
            a
          );
        });
      })(M)),
    M.exports
  );
}
var W = {exports: {}},
  et;
function yt() {
  return (
    et ||
      ((et = 1),
      (function (m) {
        (function (l, h) {
          m.exports ? (m.exports = h(l, pt())) : ((l.Flickity = l.Flickity || {}), (l.Flickity.Cell = h(l, l.getSize)));
        })(window, function (h, d) {
          function a(n, o) {
            (this.element = n), (this.parent = o), this.create();
          }
          var s = a.prototype;
          return (
            (s.create = function () {
              (this.element.style.position = 'absolute'),
                this.element.setAttribute('aria-hidden', 'true'),
                (this.x = 0),
                (this.shift = 0),
                (this.element.style[this.parent.originSide] = 0);
            }),
            (s.destroy = function () {
              this.unselect(), (this.element.style.position = '');
              var n = this.parent.originSide;
              (this.element.style[n] = ''),
                (this.element.style.transform = ''),
                this.element.removeAttribute('aria-hidden');
            }),
            (s.getSize = function () {
              this.size = d(this.element);
            }),
            (s.setPosition = function (n) {
              (this.x = n), this.updateTarget(), this.renderPosition(n);
            }),
            (s.updateTarget = s.setDefaultTarget =
              function () {
                var n = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
                this.target = this.x + this.size[n] + this.size.width * this.parent.cellAlign;
              }),
            (s.renderPosition = function (n) {
              var o = this.parent.originSide === 'left' ? 1 : -1,
                t = this.parent.options.percentPosition
                  ? n * o * (this.parent.size.innerWidth / this.size.width)
                  : n * o;
              this.element.style.transform = 'translateX(' + this.parent.getPositionValue(t) + ')';
            }),
            (s.select = function () {
              this.element.classList.add('is-selected'), this.element.removeAttribute('aria-hidden');
            }),
            (s.unselect = function () {
              this.element.classList.remove('is-selected'), this.element.setAttribute('aria-hidden', 'true');
            }),
            (s.wrapShift = function (n) {
              (this.shift = n), this.renderPosition(this.x + this.parent.slideableWidth * n);
            }),
            (s.remove = function () {
              this.element.parentNode.removeChild(this.element);
            }),
            a
          );
        });
      })(W)),
    W.exports
  );
}
var U = {exports: {}},
  it;
function St() {
  return (
    it ||
      ((it = 1),
      (function (m) {
        (function (l, h) {
          m.exports ? (m.exports = h()) : ((l.Flickity = l.Flickity || {}), (l.Flickity.Slide = h()));
        })(window, function () {
          function h(a) {
            (this.parent = a),
              (this.isOriginLeft = a.originSide == 'left'),
              (this.cells = []),
              (this.outerWidth = 0),
              (this.height = 0);
          }
          var d = h.prototype;
          return (
            (d.addCell = function (a) {
              if (
                (this.cells.push(a),
                (this.outerWidth += a.size.outerWidth),
                (this.height = Math.max(a.size.outerHeight, this.height)),
                this.cells.length == 1)
              ) {
                this.x = a.x;
                var s = this.isOriginLeft ? 'marginLeft' : 'marginRight';
                this.firstMargin = a.size[s];
              }
            }),
            (d.updateTarget = function () {
              var a = this.isOriginLeft ? 'marginRight' : 'marginLeft',
                s = this.getLastCell(),
                n = s ? s.size[a] : 0,
                o = this.outerWidth - (this.firstMargin + n);
              this.target = this.x + this.firstMargin + o * this.parent.cellAlign;
            }),
            (d.getLastCell = function () {
              return this.cells[this.cells.length - 1];
            }),
            (d.select = function () {
              this.cells.forEach(function (a) {
                a.select();
              });
            }),
            (d.unselect = function () {
              this.cells.forEach(function (a) {
                a.unselect();
              });
            }),
            (d.getCellElements = function () {
              return this.cells.map(function (a) {
                return a.element;
              });
            }),
            h
          );
        });
      })(U)),
    U.exports
  );
}
var w = {exports: {}},
  nt;
function xt() {
  return (
    nt ||
      ((nt = 1),
      (function (m) {
        (function (l, h) {
          m.exports
            ? (m.exports = h(l, _()))
            : ((l.Flickity = l.Flickity || {}), (l.Flickity.animatePrototype = h(l, l.fizzyUIUtils)));
        })(window, function (h, d) {
          var a = {};
          return (
            (a.startAnimation = function () {
              this.isAnimating || ((this.isAnimating = !0), (this.restingFrames = 0), this.animate());
            }),
            (a.animate = function () {
              this.applyDragForce(), this.applySelectedAttraction();
              var s = this.x;
              if ((this.integratePhysics(), this.positionSlider(), this.settle(s), this.isAnimating)) {
                var n = this;
                requestAnimationFrame(function () {
                  n.animate();
                });
              }
            }),
            (a.positionSlider = function () {
              var s = this.x;
              this.options.wrapAround &&
                this.cells.length > 1 &&
                ((s = d.modulo(s, this.slideableWidth)), (s -= this.slideableWidth), this.shiftWrapCells(s)),
                this.setTranslateX(s, this.isAnimating),
                this.dispatchScrollEvent();
            }),
            (a.setTranslateX = function (s, n) {
              (s += this.cursorPosition), (s = this.options.rightToLeft ? -s : s);
              var o = this.getPositionValue(s);
              this.slider.style.transform = n ? 'translate3d(' + o + ',0,0)' : 'translateX(' + o + ')';
            }),
            (a.dispatchScrollEvent = function () {
              var s = this.slides[0];
              if (s) {
                var n = -this.x - s.target,
                  o = n / this.slidesWidth;
                this.dispatchEvent('scroll', null, [o, n]);
              }
            }),
            (a.positionSliderAtSelected = function () {
              this.cells.length && ((this.x = -this.selectedSlide.target), (this.velocity = 0), this.positionSlider());
            }),
            (a.getPositionValue = function (s) {
              return this.options.percentPosition
                ? Math.round((s / this.size.innerWidth) * 1e4) * 0.01 + '%'
                : Math.round(s) + 'px';
            }),
            (a.settle = function (s) {
              var n = !this.isPointerDown && Math.round(this.x * 100) == Math.round(s * 100);
              n && this.restingFrames++,
                this.restingFrames > 2 &&
                  ((this.isAnimating = !1),
                  delete this.isFreeScrolling,
                  this.positionSlider(),
                  this.dispatchEvent('settle', null, [this.selectedIndex]));
            }),
            (a.shiftWrapCells = function (s) {
              var n = this.cursorPosition + s;
              this._shiftCells(this.beforeShiftCells, n, -1);
              var o = this.size.innerWidth - (s + this.slideableWidth + this.cursorPosition);
              this._shiftCells(this.afterShiftCells, o, 1);
            }),
            (a._shiftCells = function (s, n, o) {
              for (var t = 0; t < s.length; t++) {
                var e = s[t],
                  r = n > 0 ? o : 0;
                e.wrapShift(r), (n -= e.size.outerWidth);
              }
            }),
            (a._unshiftCells = function (s) {
              if (!(!s || !s.length)) for (var n = 0; n < s.length; n++) s[n].wrapShift(0);
            }),
            (a.integratePhysics = function () {
              (this.x += this.velocity), (this.velocity *= this.getFrictionFactor());
            }),
            (a.applyForce = function (s) {
              this.velocity += s;
            }),
            (a.getFrictionFactor = function () {
              return 1 - this.options[this.isFreeScrolling ? 'freeScrollFriction' : 'friction'];
            }),
            (a.getRestingPosition = function () {
              return this.x + this.velocity / (1 - this.getFrictionFactor());
            }),
            (a.applyDragForce = function () {
              if (!(!this.isDraggable || !this.isPointerDown)) {
                var s = this.dragX - this.x,
                  n = s - this.velocity;
                this.applyForce(n);
              }
            }),
            (a.applySelectedAttraction = function () {
              var s = this.isDraggable && this.isPointerDown;
              if (!(s || this.isFreeScrolling || !this.slides.length)) {
                var n = this.selectedSlide.target * -1 - this.x,
                  o = n * this.options.selectedAttraction;
                this.applyForce(o);
              }
            }),
            a
          );
        });
      })(w)),
    w.exports
  );
}
var st;
function z() {
  return (
    st ||
      ((st = 1),
      (function (m) {
        (function (l, h) {
          if (m.exports) m.exports = h(l, G(), pt(), _(), yt(), St(), xt());
          else {
            var d = l.Flickity;
            l.Flickity = h(l, l.EvEmitter, l.getSize, l.fizzyUIUtils, d.Cell, d.Slide, d.animatePrototype);
          }
        })(window, function (h, d, a, s, n, o, t) {
          var e = h.jQuery,
            r = h.getComputedStyle,
            c = h.console;
          function g(i, u) {
            for (i = s.makeArray(i); i.length; ) u.appendChild(i.shift());
          }
          var f = 0,
            S = {};
          function v(i, u) {
            var y = s.getQueryElement(i);
            if (!y) {
              c && c.error('Bad element for Flickity: ' + (y || i));
              return;
            }
            if (((this.element = y), this.element.flickityGUID)) {
              var x = S[this.element.flickityGUID];
              return x && x.option(u), x;
            }
            e && (this.$element = e(this.element)),
              (this.options = s.extend({}, this.constructor.defaults)),
              this.option(u),
              this._create();
          }
          (v.defaults = {
            accessibility: !0,
            cellAlign: 'center',
            freeScrollFriction: 0.075,
            friction: 0.28,
            namespaceJQueryEvents: !0,
            percentPosition: !0,
            resize: !0,
            selectedAttraction: 0.025,
            setGallerySize: !0,
          }),
            (v.createMethods = []);
          var p = v.prototype;
          s.extend(p, d.prototype),
            (p._create = function () {
              var i = (this.guid = ++f);
              (this.element.flickityGUID = i),
                (S[i] = this),
                (this.selectedIndex = 0),
                (this.restingFrames = 0),
                (this.x = 0),
                (this.velocity = 0),
                (this.originSide = this.options.rightToLeft ? 'right' : 'left'),
                (this.viewport = document.createElement('div')),
                (this.viewport.className = 'flickity-viewport'),
                this._createSlider(),
                (this.options.resize || this.options.watchCSS) && h.addEventListener('resize', this);
              for (var u in this.options.on) {
                var y = this.options.on[u];
                this.on(u, y);
              }
              v.createMethods.forEach(function (x) {
                this[x]();
              }, this),
                this.options.watchCSS ? this.watchCSS() : this.activate();
            }),
            (p.option = function (i) {
              s.extend(this.options, i);
            }),
            (p.activate = function () {
              if (!this.isActive) {
                (this.isActive = !0),
                  this.element.classList.add('flickity-enabled'),
                  this.options.rightToLeft && this.element.classList.add('flickity-rtl'),
                  this.getSize();
                var i = this._filterFindCellElements(this.element.children);
                g(i, this.slider),
                  this.viewport.appendChild(this.slider),
                  this.element.appendChild(this.viewport),
                  this.reloadCells(),
                  this.options.accessibility &&
                    ((this.element.tabIndex = 0), this.element.addEventListener('keydown', this)),
                  this.emitEvent('activate'),
                  this.selectInitialIndex(),
                  (this.isInitActivated = !0),
                  this.dispatchEvent('ready');
              }
            }),
            (p._createSlider = function () {
              var i = document.createElement('div');
              (i.className = 'flickity-slider'), (i.style[this.originSide] = 0), (this.slider = i);
            }),
            (p._filterFindCellElements = function (i) {
              return s.filterFindElements(i, this.options.cellSelector);
            }),
            (p.reloadCells = function () {
              (this.cells = this._makeCells(this.slider.children)),
                this.positionCells(),
                this._getWrapShiftCells(),
                this.setGallerySize();
            }),
            (p._makeCells = function (i) {
              var u = this._filterFindCellElements(i),
                y = u.map(function (x) {
                  return new n(x, this);
                }, this);
              return y;
            }),
            (p.getLastCell = function () {
              return this.cells[this.cells.length - 1];
            }),
            (p.getLastSlide = function () {
              return this.slides[this.slides.length - 1];
            }),
            (p.positionCells = function () {
              this._sizeCells(this.cells), this._positionCells(0);
            }),
            (p._positionCells = function (i) {
              (i = i || 0), (this.maxCellHeight = (i && this.maxCellHeight) || 0);
              var u = 0;
              if (i > 0) {
                var y = this.cells[i - 1];
                u = y.x + y.size.outerWidth;
              }
              for (var x = this.cells.length, E = i; E < x; E++) {
                var b = this.cells[E];
                b.setPosition(u),
                  (u += b.size.outerWidth),
                  (this.maxCellHeight = Math.max(b.size.outerHeight, this.maxCellHeight));
              }
              (this.slideableWidth = u),
                this.updateSlides(),
                this._containSlides(),
                (this.slidesWidth = x ? this.getLastSlide().target - this.slides[0].target : 0);
            }),
            (p._sizeCells = function (i) {
              i.forEach(function (u) {
                u.getSize();
              });
            }),
            (p.updateSlides = function () {
              if (((this.slides = []), !!this.cells.length)) {
                var i = new o(this);
                this.slides.push(i);
                var u = this.originSide == 'left',
                  y = u ? 'marginRight' : 'marginLeft',
                  x = this._getCanCellFit();
                this.cells.forEach(function (E, b) {
                  if (!i.cells.length) {
                    i.addCell(E);
                    return;
                  }
                  var C = i.outerWidth - i.firstMargin + (E.size.outerWidth - E.size[y]);
                  x.call(this, b, C) || (i.updateTarget(), (i = new o(this)), this.slides.push(i)), i.addCell(E);
                }, this),
                  i.updateTarget(),
                  this.updateSelectedSlide();
              }
            }),
            (p._getCanCellFit = function () {
              var i = this.options.groupCells;
              if (i) {
                if (typeof i == 'number') {
                  var u = parseInt(i, 10);
                  return function (E) {
                    return E % u !== 0;
                  };
                }
              } else
                return function () {
                  return !1;
                };
              var y = typeof i == 'string' && i.match(/^(\d+)%$/),
                x = y ? parseInt(y[1], 10) / 100 : 1;
              return function (E, b) {
                return b <= (this.size.innerWidth + 1) * x;
              };
            }),
            (p._init = p.reposition =
              function () {
                this.positionCells(), this.positionSliderAtSelected();
              }),
            (p.getSize = function () {
              (this.size = a(this.element)),
                this.setCellAlign(),
                (this.cursorPosition = this.size.innerWidth * this.cellAlign);
            });
          var D = {center: {left: 0.5, right: 0.5}, left: {left: 0, right: 1}, right: {right: 0, left: 1}};
          return (
            (p.setCellAlign = function () {
              var i = D[this.options.cellAlign];
              this.cellAlign = i ? i[this.originSide] : this.options.cellAlign;
            }),
            (p.setGallerySize = function () {
              if (this.options.setGallerySize) {
                var i =
                  this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
                this.viewport.style.height = i + 'px';
              }
            }),
            (p._getWrapShiftCells = function () {
              if (this.options.wrapAround) {
                this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
                var i = this.cursorPosition,
                  u = this.cells.length - 1;
                (this.beforeShiftCells = this._getGapCells(i, u, -1)),
                  (i = this.size.innerWidth - this.cursorPosition),
                  (this.afterShiftCells = this._getGapCells(i, 0, 1));
              }
            }),
            (p._getGapCells = function (i, u, y) {
              for (var x = []; i > 0; ) {
                var E = this.cells[u];
                if (!E) break;
                x.push(E), (u += y), (i -= E.size.outerWidth);
              }
              return x;
            }),
            (p._containSlides = function () {
              if (!(!this.options.contain || this.options.wrapAround || !this.cells.length)) {
                var i = this.options.rightToLeft,
                  u = i ? 'marginRight' : 'marginLeft',
                  y = i ? 'marginLeft' : 'marginRight',
                  x = this.slideableWidth - this.getLastCell().size[y],
                  E = x < this.size.innerWidth,
                  b = this.cursorPosition + this.cells[0].size[u],
                  C = x - this.size.innerWidth * (1 - this.cellAlign);
                this.slides.forEach(function (P) {
                  E
                    ? (P.target = x * this.cellAlign)
                    : ((P.target = Math.max(P.target, b)), (P.target = Math.min(P.target, C)));
                }, this);
              }
            }),
            (p.dispatchEvent = function (i, u, y) {
              var x = u ? [u].concat(y) : y;
              if ((this.emitEvent(i, x), e && this.$element)) {
                i += this.options.namespaceJQueryEvents ? '.flickity' : '';
                var E = i;
                if (u) {
                  var b = new e.Event(u);
                  (b.type = i), (E = b);
                }
                this.$element.trigger(E, y);
              }
            }),
            (p.select = function (i, u, y) {
              if (
                this.isActive &&
                ((i = parseInt(i, 10)),
                this._wrapSelect(i),
                (this.options.wrapAround || u) && (i = s.modulo(i, this.slides.length)),
                !!this.slides[i])
              ) {
                var x = this.selectedIndex;
                (this.selectedIndex = i),
                  this.updateSelectedSlide(),
                  y ? this.positionSliderAtSelected() : this.startAnimation(),
                  this.options.adaptiveHeight && this.setGallerySize(),
                  this.dispatchEvent('select', null, [i]),
                  i != x && this.dispatchEvent('change', null, [i]),
                  this.dispatchEvent('cellSelect');
              }
            }),
            (p._wrapSelect = function (i) {
              var u = this.slides.length,
                y = this.options.wrapAround && u > 1;
              if (!y) return i;
              var x = s.modulo(i, u),
                E = Math.abs(x - this.selectedIndex),
                b = Math.abs(x + u - this.selectedIndex),
                C = Math.abs(x - u - this.selectedIndex);
              !this.isDragSelect && b < E ? (i += u) : !this.isDragSelect && C < E && (i -= u),
                i < 0 ? (this.x -= this.slideableWidth) : i >= u && (this.x += this.slideableWidth);
            }),
            (p.previous = function (i, u) {
              this.select(this.selectedIndex - 1, i, u);
            }),
            (p.next = function (i, u) {
              this.select(this.selectedIndex + 1, i, u);
            }),
            (p.updateSelectedSlide = function () {
              var i = this.slides[this.selectedIndex];
              i &&
                (this.unselectSelectedSlide(),
                (this.selectedSlide = i),
                i.select(),
                (this.selectedCells = i.cells),
                (this.selectedElements = i.getCellElements()),
                (this.selectedCell = i.cells[0]),
                (this.selectedElement = this.selectedElements[0]));
            }),
            (p.unselectSelectedSlide = function () {
              this.selectedSlide && this.selectedSlide.unselect();
            }),
            (p.selectInitialIndex = function () {
              var i = this.options.initialIndex;
              if (this.isInitActivated) {
                this.select(this.selectedIndex, !1, !0);
                return;
              }
              if (i && typeof i == 'string') {
                var u = this.queryCell(i);
                if (u) {
                  this.selectCell(i, !1, !0);
                  return;
                }
              }
              var y = 0;
              i && this.slides[i] && (y = i), this.select(y, !1, !0);
            }),
            (p.selectCell = function (i, u, y) {
              var x = this.queryCell(i);
              if (x) {
                var E = this.getCellSlideIndex(x);
                this.select(E, u, y);
              }
            }),
            (p.getCellSlideIndex = function (i) {
              for (var u = 0; u < this.slides.length; u++) {
                var y = this.slides[u],
                  x = y.cells.indexOf(i);
                if (x != -1) return u;
              }
            }),
            (p.getCell = function (i) {
              for (var u = 0; u < this.cells.length; u++) {
                var y = this.cells[u];
                if (y.element == i) return y;
              }
            }),
            (p.getCells = function (i) {
              i = s.makeArray(i);
              var u = [];
              return (
                i.forEach(function (y) {
                  var x = this.getCell(y);
                  x && u.push(x);
                }, this),
                u
              );
            }),
            (p.getCellElements = function () {
              return this.cells.map(function (i) {
                return i.element;
              });
            }),
            (p.getParentCell = function (i) {
              var u = this.getCell(i);
              return u || ((i = s.getParent(i, '.flickity-slider > *')), this.getCell(i));
            }),
            (p.getAdjacentCellElements = function (i, u) {
              if (!i) return this.selectedSlide.getCellElements();
              u = u === void 0 ? this.selectedIndex : u;
              var y = this.slides.length;
              if (1 + i * 2 >= y) return this.getCellElements();
              for (var x = [], E = u - i; E <= u + i; E++) {
                var b = this.options.wrapAround ? s.modulo(E, y) : E,
                  C = this.slides[b];
                C && (x = x.concat(C.getCellElements()));
              }
              return x;
            }),
            (p.queryCell = function (i) {
              if (typeof i == 'number') return this.cells[i];
              if (typeof i == 'string') {
                if (i.match(/^[#.]?[\d/]/)) return;
                i = this.element.querySelector(i);
              }
              return this.getCell(i);
            }),
            (p.uiChange = function () {
              this.emitEvent('uiChange');
            }),
            (p.childUIPointerDown = function (i) {
              i.type != 'touchstart' && i.preventDefault(), this.focus();
            }),
            (p.onresize = function () {
              this.watchCSS(), this.resize();
            }),
            s.debounceMethod(v, 'onresize', 150),
            (p.resize = function () {
              if (!(!this.isActive || this.isAnimating || this.isDragging)) {
                this.getSize(),
                  this.options.wrapAround && (this.x = s.modulo(this.x, this.slideableWidth)),
                  this.positionCells(),
                  this._getWrapShiftCells(),
                  this.setGallerySize(),
                  this.emitEvent('resize');
                var i = this.selectedElements && this.selectedElements[0];
                this.selectCell(i, !1, !0);
              }
            }),
            (p.watchCSS = function () {
              var i = this.options.watchCSS;
              if (i) {
                var u = r(this.element, ':after').content;
                u.indexOf('flickity') != -1 ? this.activate() : this.deactivate();
              }
            }),
            (p.onkeydown = function (i) {
              var u = document.activeElement && document.activeElement != this.element;
              if (!(!this.options.accessibility || u)) {
                var y = v.keyboardHandlers[i.keyCode];
                y && y.call(this);
              }
            }),
            (v.keyboardHandlers = {
              37: function () {
                var i = this.options.rightToLeft ? 'next' : 'previous';
                this.uiChange(), this[i]();
              },
              39: function () {
                var i = this.options.rightToLeft ? 'previous' : 'next';
                this.uiChange(), this[i]();
              },
            }),
            (p.focus = function () {
              var i = h.pageYOffset;
              this.element.focus({preventScroll: !0}), h.pageYOffset != i && h.scrollTo(h.pageXOffset, i);
            }),
            (p.deactivate = function () {
              this.isActive &&
                (this.element.classList.remove('flickity-enabled'),
                this.element.classList.remove('flickity-rtl'),
                this.unselectSelectedSlide(),
                this.cells.forEach(function (i) {
                  i.destroy();
                }),
                this.element.removeChild(this.viewport),
                g(this.slider.children, this.element),
                this.options.accessibility &&
                  (this.element.removeAttribute('tabIndex'), this.element.removeEventListener('keydown', this)),
                (this.isActive = !1),
                this.emitEvent('deactivate'));
            }),
            (p.destroy = function () {
              this.deactivate(),
                h.removeEventListener('resize', this),
                this.allOff(),
                this.emitEvent('destroy'),
                e && this.$element && e.removeData(this.element, 'flickity'),
                delete this.element.flickityGUID,
                delete S[this.guid];
            }),
            s.extend(p, t),
            (v.data = function (i) {
              i = s.getQueryElement(i);
              var u = i && i.flickityGUID;
              return u && S[u];
            }),
            s.htmlInit(v, 'flickity'),
            e && e.bridget && e.bridget('flickity', v),
            (v.setJQuery = function (i) {
              e = i;
            }),
            (v.Cell = n),
            (v.Slide = o),
            v
          );
        });
      })(k)),
    k.exports
  );
}
var R = {exports: {}},
  F = {exports: {}},
  q = {exports: {}};
/*!
 * Unipointer v2.4.0
 * base class for doing one thing with pointer event
 * MIT license
 */ var rt;
function V() {
  return (
    rt ||
      ((rt = 1),
      (function (m) {
        (function (l, h) {
          m.exports ? (m.exports = h(l, G())) : (l.Unipointer = h(l, l.EvEmitter));
        })(window, function (h, d) {
          function a() {}
          function s() {}
          var n = (s.prototype = Object.create(d.prototype));
          (n.bindStartEvent = function (t) {
            this._bindStartEvent(t, !0);
          }),
            (n.unbindStartEvent = function (t) {
              this._bindStartEvent(t, !1);
            }),
            (n._bindStartEvent = function (t, e) {
              e = e === void 0 ? !0 : e;
              var r = e ? 'addEventListener' : 'removeEventListener',
                c = 'mousedown';
              'ontouchstart' in h ? (c = 'touchstart') : h.PointerEvent && (c = 'pointerdown'), t[r](c, this);
            }),
            (n.handleEvent = function (t) {
              var e = 'on' + t.type;
              this[e] && this[e](t);
            }),
            (n.getTouch = function (t) {
              for (var e = 0; e < t.length; e++) {
                var r = t[e];
                if (r.identifier == this.pointerIdentifier) return r;
              }
            }),
            (n.onmousedown = function (t) {
              var e = t.button;
              (e && e !== 0 && e !== 1) || this._pointerDown(t, t);
            }),
            (n.ontouchstart = function (t) {
              this._pointerDown(t, t.changedTouches[0]);
            }),
            (n.onpointerdown = function (t) {
              this._pointerDown(t, t);
            }),
            (n._pointerDown = function (t, e) {
              t.button ||
                this.isPointerDown ||
                ((this.isPointerDown = !0),
                (this.pointerIdentifier = e.pointerId !== void 0 ? e.pointerId : e.identifier),
                this.pointerDown(t, e));
            }),
            (n.pointerDown = function (t, e) {
              this._bindPostStartEvents(t), this.emitEvent('pointerDown', [t, e]);
            });
          var o = {
            mousedown: ['mousemove', 'mouseup'],
            touchstart: ['touchmove', 'touchend', 'touchcancel'],
            pointerdown: ['pointermove', 'pointerup', 'pointercancel'],
          };
          return (
            (n._bindPostStartEvents = function (t) {
              if (t) {
                var e = o[t.type];
                e.forEach(function (r) {
                  h.addEventListener(r, this);
                }, this),
                  (this._boundPointerEvents = e);
              }
            }),
            (n._unbindPostStartEvents = function () {
              this._boundPointerEvents &&
                (this._boundPointerEvents.forEach(function (t) {
                  h.removeEventListener(t, this);
                }, this),
                delete this._boundPointerEvents);
            }),
            (n.onmousemove = function (t) {
              this._pointerMove(t, t);
            }),
            (n.onpointermove = function (t) {
              t.pointerId == this.pointerIdentifier && this._pointerMove(t, t);
            }),
            (n.ontouchmove = function (t) {
              var e = this.getTouch(t.changedTouches);
              e && this._pointerMove(t, e);
            }),
            (n._pointerMove = function (t, e) {
              this.pointerMove(t, e);
            }),
            (n.pointerMove = function (t, e) {
              this.emitEvent('pointerMove', [t, e]);
            }),
            (n.onmouseup = function (t) {
              this._pointerUp(t, t);
            }),
            (n.onpointerup = function (t) {
              t.pointerId == this.pointerIdentifier && this._pointerUp(t, t);
            }),
            (n.ontouchend = function (t) {
              var e = this.getTouch(t.changedTouches);
              e && this._pointerUp(t, e);
            }),
            (n._pointerUp = function (t, e) {
              this._pointerDone(), this.pointerUp(t, e);
            }),
            (n.pointerUp = function (t, e) {
              this.emitEvent('pointerUp', [t, e]);
            }),
            (n._pointerDone = function () {
              this._pointerReset(), this._unbindPostStartEvents(), this.pointerDone();
            }),
            (n._pointerReset = function () {
              (this.isPointerDown = !1), delete this.pointerIdentifier;
            }),
            (n.pointerDone = a),
            (n.onpointercancel = function (t) {
              t.pointerId == this.pointerIdentifier && this._pointerCancel(t, t);
            }),
            (n.ontouchcancel = function (t) {
              var e = this.getTouch(t.changedTouches);
              e && this._pointerCancel(t, e);
            }),
            (n._pointerCancel = function (t, e) {
              this._pointerDone(), this.pointerCancel(t, e);
            }),
            (n.pointerCancel = function (t, e) {
              this.emitEvent('pointerCancel', [t, e]);
            }),
            (s.getPointerPoint = function (t) {
              return {x: t.pageX, y: t.pageY};
            }),
            s
          );
        });
      })(q)),
    q.exports
  );
}
/*!
 * Unidragger v2.4.0
 * Draggable base class
 * MIT license
 */ var ot;
function Et() {
  return (
    ot ||
      ((ot = 1),
      (function (m) {
        (function (l, h) {
          m.exports ? (m.exports = h(l, V())) : (l.Unidragger = h(l, l.Unipointer));
        })(window, function (h, d) {
          function a() {}
          var s = (a.prototype = Object.create(d.prototype));
          (s.bindHandles = function () {
            this._bindHandles(!0);
          }),
            (s.unbindHandles = function () {
              this._bindHandles(!1);
            }),
            (s._bindHandles = function (t) {
              t = t === void 0 ? !0 : t;
              for (
                var e = t ? 'addEventListener' : 'removeEventListener', r = t ? this._touchActionValue : '', c = 0;
                c < this.handles.length;
                c++
              ) {
                var g = this.handles[c];
                this._bindStartEvent(g, t), g[e]('click', this), h.PointerEvent && (g.style.touchAction = r);
              }
            }),
            (s._touchActionValue = 'none'),
            (s.pointerDown = function (t, e) {
              var r = this.okayPointerDown(t);
              r &&
                ((this.pointerDownPointer = {pageX: e.pageX, pageY: e.pageY}),
                t.preventDefault(),
                this.pointerDownBlur(),
                this._bindPostStartEvents(t),
                this.emitEvent('pointerDown', [t, e]));
            });
          var n = {TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0},
            o = {radio: !0, checkbox: !0, button: !0, submit: !0, image: !0, file: !0};
          return (
            (s.okayPointerDown = function (t) {
              var e = n[t.target.nodeName],
                r = o[t.target.type],
                c = !e || r;
              return c || this._pointerReset(), c;
            }),
            (s.pointerDownBlur = function () {
              var t = document.activeElement,
                e = t && t.blur && t != document.body;
              e && t.blur();
            }),
            (s.pointerMove = function (t, e) {
              var r = this._dragPointerMove(t, e);
              this.emitEvent('pointerMove', [t, e, r]), this._dragMove(t, e, r);
            }),
            (s._dragPointerMove = function (t, e) {
              var r = {x: e.pageX - this.pointerDownPointer.pageX, y: e.pageY - this.pointerDownPointer.pageY};
              return !this.isDragging && this.hasDragStarted(r) && this._dragStart(t, e), r;
            }),
            (s.hasDragStarted = function (t) {
              return Math.abs(t.x) > 3 || Math.abs(t.y) > 3;
            }),
            (s.pointerUp = function (t, e) {
              this.emitEvent('pointerUp', [t, e]), this._dragPointerUp(t, e);
            }),
            (s._dragPointerUp = function (t, e) {
              this.isDragging ? this._dragEnd(t, e) : this._staticClick(t, e);
            }),
            (s._dragStart = function (t, e) {
              (this.isDragging = !0), (this.isPreventingClicks = !0), this.dragStart(t, e);
            }),
            (s.dragStart = function (t, e) {
              this.emitEvent('dragStart', [t, e]);
            }),
            (s._dragMove = function (t, e, r) {
              this.isDragging && this.dragMove(t, e, r);
            }),
            (s.dragMove = function (t, e, r) {
              t.preventDefault(), this.emitEvent('dragMove', [t, e, r]);
            }),
            (s._dragEnd = function (t, e) {
              (this.isDragging = !1),
                setTimeout(
                  function () {
                    delete this.isPreventingClicks;
                  }.bind(this)
                ),
                this.dragEnd(t, e);
            }),
            (s.dragEnd = function (t, e) {
              this.emitEvent('dragEnd', [t, e]);
            }),
            (s.onclick = function (t) {
              this.isPreventingClicks && t.preventDefault();
            }),
            (s._staticClick = function (t, e) {
              (this.isIgnoringMouseUp && t.type == 'mouseup') ||
                (this.staticClick(t, e),
                t.type != 'mouseup' &&
                  ((this.isIgnoringMouseUp = !0),
                  setTimeout(
                    function () {
                      delete this.isIgnoringMouseUp;
                    }.bind(this),
                    400
                  )));
            }),
            (s.staticClick = function (t, e) {
              this.emitEvent('staticClick', [t, e]);
            }),
            (a.getPointerPoint = d.getPointerPoint),
            a
          );
        });
      })(F)),
    F.exports
  );
}
var at;
function bt() {
  return (
    at ||
      ((at = 1),
      (function (m) {
        (function (l, h) {
          m.exports
            ? (m.exports = h(l, z(), Et(), _()))
            : (l.Flickity = h(l, l.Flickity, l.Unidragger, l.fizzyUIUtils));
        })(window, function (h, d, a, s) {
          s.extend(d.defaults, {draggable: '>1', dragThreshold: 3}), d.createMethods.push('_createDrag');
          var n = d.prototype;
          s.extend(n, a.prototype),
            (n._touchActionValue = 'pan-y'),
            (n._createDrag = function () {
              this.on('activate', this.onActivateDrag),
                this.on('uiChange', this._uiChangeDrag),
                this.on('deactivate', this.onDeactivateDrag),
                this.on('cellChange', this.updateDraggable);
            }),
            (n.onActivateDrag = function () {
              (this.handles = [this.viewport]), this.bindHandles(), this.updateDraggable();
            }),
            (n.onDeactivateDrag = function () {
              this.unbindHandles(), this.element.classList.remove('is-draggable');
            }),
            (n.updateDraggable = function () {
              this.options.draggable == '>1'
                ? (this.isDraggable = this.slides.length > 1)
                : (this.isDraggable = this.options.draggable),
                this.isDraggable
                  ? this.element.classList.add('is-draggable')
                  : this.element.classList.remove('is-draggable');
            }),
            (n.bindDrag = function () {
              (this.options.draggable = !0), this.updateDraggable();
            }),
            (n.unbindDrag = function () {
              (this.options.draggable = !1), this.updateDraggable();
            }),
            (n._uiChangeDrag = function () {
              delete this.isFreeScrolling;
            }),
            (n.pointerDown = function (e, r) {
              if (!this.isDraggable) {
                this._pointerDownDefault(e, r);
                return;
              }
              var c = this.okayPointerDown(e);
              c &&
                (this._pointerDownPreventDefault(e),
                this.pointerDownFocus(e),
                document.activeElement != this.element && this.pointerDownBlur(),
                (this.dragX = this.x),
                this.viewport.classList.add('is-pointer-down'),
                (this.pointerDownScroll = t()),
                h.addEventListener('scroll', this),
                this._pointerDownDefault(e, r));
            }),
            (n._pointerDownDefault = function (e, r) {
              (this.pointerDownPointer = {pageX: r.pageX, pageY: r.pageY}),
                this._bindPostStartEvents(e),
                this.dispatchEvent('pointerDown', e, [r]);
            });
          var o = {INPUT: !0, TEXTAREA: !0, SELECT: !0};
          (n.pointerDownFocus = function (e) {
            var r = o[e.target.nodeName];
            r || this.focus();
          }),
            (n._pointerDownPreventDefault = function (e) {
              var r = e.type == 'touchstart',
                c = e.pointerType == 'touch',
                g = o[e.target.nodeName];
              !r && !c && !g && e.preventDefault();
            }),
            (n.hasDragStarted = function (e) {
              return Math.abs(e.x) > this.options.dragThreshold;
            }),
            (n.pointerUp = function (e, r) {
              delete this.isTouchScrolling,
                this.viewport.classList.remove('is-pointer-down'),
                this.dispatchEvent('pointerUp', e, [r]),
                this._dragPointerUp(e, r);
            }),
            (n.pointerDone = function () {
              h.removeEventListener('scroll', this), delete this.pointerDownScroll;
            }),
            (n.dragStart = function (e, r) {
              this.isDraggable &&
                ((this.dragStartPosition = this.x),
                this.startAnimation(),
                h.removeEventListener('scroll', this),
                this.dispatchEvent('dragStart', e, [r]));
            }),
            (n.pointerMove = function (e, r) {
              var c = this._dragPointerMove(e, r);
              this.dispatchEvent('pointerMove', e, [r, c]), this._dragMove(e, r, c);
            }),
            (n.dragMove = function (e, r, c) {
              if (this.isDraggable) {
                e.preventDefault(), (this.previousDragX = this.dragX);
                var g = this.options.rightToLeft ? -1 : 1;
                this.options.wrapAround && (c.x %= this.slideableWidth);
                var f = this.dragStartPosition + c.x * g;
                if (!this.options.wrapAround && this.slides.length) {
                  var S = Math.max(-this.slides[0].target, this.dragStartPosition);
                  f = f > S ? (f + S) * 0.5 : f;
                  var v = Math.min(-this.getLastSlide().target, this.dragStartPosition);
                  f = f < v ? (f + v) * 0.5 : f;
                }
                (this.dragX = f), (this.dragMoveTime = new Date()), this.dispatchEvent('dragMove', e, [r, c]);
              }
            }),
            (n.dragEnd = function (e, r) {
              if (this.isDraggable) {
                this.options.freeScroll && (this.isFreeScrolling = !0);
                var c = this.dragEndRestingSelect();
                if (this.options.freeScroll && !this.options.wrapAround) {
                  var g = this.getRestingPosition();
                  this.isFreeScrolling = -g > this.slides[0].target && -g < this.getLastSlide().target;
                } else !this.options.freeScroll && c == this.selectedIndex && (c += this.dragEndBoostSelect());
                delete this.previousDragX,
                  (this.isDragSelect = this.options.wrapAround),
                  this.select(c),
                  delete this.isDragSelect,
                  this.dispatchEvent('dragEnd', e, [r]);
              }
            }),
            (n.dragEndRestingSelect = function () {
              var e = this.getRestingPosition(),
                r = Math.abs(this.getSlideDistance(-e, this.selectedIndex)),
                c = this._getClosestResting(e, r, 1),
                g = this._getClosestResting(e, r, -1),
                f = c.distance < g.distance ? c.index : g.index;
              return f;
            }),
            (n._getClosestResting = function (e, r, c) {
              for (
                var g = this.selectedIndex,
                  f = 1 / 0,
                  S =
                    this.options.contain && !this.options.wrapAround
                      ? function (v, p) {
                          return v <= p;
                        }
                      : function (v, p) {
                          return v < p;
                        };
                S(r, f) && ((g += c), (f = r), (r = this.getSlideDistance(-e, g)), r !== null);

              )
                r = Math.abs(r);
              return {distance: f, index: g - c};
            }),
            (n.getSlideDistance = function (e, r) {
              var c = this.slides.length,
                g = this.options.wrapAround && c > 1,
                f = g ? s.modulo(r, c) : r,
                S = this.slides[f];
              if (!S) return null;
              var v = g ? this.slideableWidth * Math.floor(r / c) : 0;
              return e - (S.target + v);
            }),
            (n.dragEndBoostSelect = function () {
              if (this.previousDragX === void 0 || !this.dragMoveTime || new Date() - this.dragMoveTime > 100) return 0;
              var e = this.getSlideDistance(-this.dragX, this.selectedIndex),
                r = this.previousDragX - this.dragX;
              return e > 0 && r > 0 ? 1 : e < 0 && r < 0 ? -1 : 0;
            }),
            (n.staticClick = function (e, r) {
              var c = this.getParentCell(e.target),
                g = c && c.element,
                f = c && this.cells.indexOf(c);
              this.dispatchEvent('staticClick', e, [r, g, f]);
            }),
            (n.onscroll = function () {
              var e = t(),
                r = this.pointerDownScroll.x - e.x,
                c = this.pointerDownScroll.y - e.y;
              (Math.abs(r) > 3 || Math.abs(c) > 3) && this._pointerDone();
            });
          function t() {
            return {x: h.pageXOffset, y: h.pageYOffset};
          }
          return d;
        });
      })(R)),
    R.exports
  );
}
var B = {exports: {}},
  ht;
function Ct() {
  return (
    ht ||
      ((ht = 1),
      (function (m) {
        (function (l, h) {
          m.exports ? (m.exports = h(l, z(), V(), _())) : h(l, l.Flickity, l.Unipointer, l.fizzyUIUtils);
        })(window, function (h, d, a, s) {
          var n = 'http://www.w3.org/2000/svg';
          function o(r, c) {
            (this.direction = r), (this.parent = c), this._create();
          }
          (o.prototype = Object.create(a.prototype)),
            (o.prototype._create = function () {
              (this.isEnabled = !0), (this.isPrevious = this.direction == -1);
              var r = this.parent.options.rightToLeft ? 1 : -1;
              this.isLeft = this.direction == r;
              var c = (this.element = document.createElement('button'));
              (c.className = 'flickity-button flickity-prev-next-button'),
                (c.className += this.isPrevious ? ' previous' : ' next'),
                c.setAttribute('type', 'button'),
                this.disable(),
                c.setAttribute('aria-label', this.isPrevious ? 'Previous' : 'Next');
              var g = this.createSVG();
              c.appendChild(g),
                this.parent.on('select', this.update.bind(this)),
                this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
            }),
            (o.prototype.activate = function () {
              this.bindStartEvent(this.element),
                this.element.addEventListener('click', this),
                this.parent.element.appendChild(this.element);
            }),
            (o.prototype.deactivate = function () {
              this.parent.element.removeChild(this.element),
                this.unbindStartEvent(this.element),
                this.element.removeEventListener('click', this);
            }),
            (o.prototype.createSVG = function () {
              var r = document.createElementNS(n, 'svg');
              r.setAttribute('class', 'flickity-button-icon'), r.setAttribute('viewBox', '0 0 100 100');
              var c = document.createElementNS(n, 'path'),
                g = t(this.parent.options.arrowShape);
              return (
                c.setAttribute('d', g),
                c.setAttribute('class', 'arrow'),
                this.isLeft || c.setAttribute('transform', 'translate(100, 100) rotate(180) '),
                r.appendChild(c),
                r
              );
            });
          function t(r) {
            return typeof r == 'string'
              ? r
              : 'M ' +
                  r.x0 +
                  ',50 L ' +
                  r.x1 +
                  ',' +
                  (r.y1 + 50) +
                  ' L ' +
                  r.x2 +
                  ',' +
                  (r.y2 + 50) +
                  ' L ' +
                  r.x3 +
                  ',50  L ' +
                  r.x2 +
                  ',' +
                  (50 - r.y2) +
                  ' L ' +
                  r.x1 +
                  ',' +
                  (50 - r.y1) +
                  ' Z';
          }
          (o.prototype.handleEvent = s.handleEvent),
            (o.prototype.onclick = function () {
              if (this.isEnabled) {
                this.parent.uiChange();
                var r = this.isPrevious ? 'previous' : 'next';
                this.parent[r]();
              }
            }),
            (o.prototype.enable = function () {
              this.isEnabled || ((this.element.disabled = !1), (this.isEnabled = !0));
            }),
            (o.prototype.disable = function () {
              this.isEnabled && ((this.element.disabled = !0), (this.isEnabled = !1));
            }),
            (o.prototype.update = function () {
              var r = this.parent.slides;
              if (this.parent.options.wrapAround && r.length > 1) {
                this.enable();
                return;
              }
              var c = r.length ? r.length - 1 : 0,
                g = this.isPrevious ? 0 : c,
                f = this.parent.selectedIndex == g ? 'disable' : 'enable';
              this[f]();
            }),
            (o.prototype.destroy = function () {
              this.deactivate(), this.allOff();
            }),
            s.extend(d.defaults, {prevNextButtons: !0, arrowShape: {x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30}}),
            d.createMethods.push('_createPrevNextButtons');
          var e = d.prototype;
          return (
            (e._createPrevNextButtons = function () {
              this.options.prevNextButtons &&
                ((this.prevButton = new o(-1, this)),
                (this.nextButton = new o(1, this)),
                this.on('activate', this.activatePrevNextButtons));
            }),
            (e.activatePrevNextButtons = function () {
              this.prevButton.activate(),
                this.nextButton.activate(),
                this.on('deactivate', this.deactivatePrevNextButtons);
            }),
            (e.deactivatePrevNextButtons = function () {
              this.prevButton.deactivate(),
                this.nextButton.deactivate(),
                this.off('deactivate', this.deactivatePrevNextButtons);
            }),
            (d.PrevNextButton = o),
            d
          );
        });
      })(B)),
    B.exports
  );
}
var O = {exports: {}},
  lt;
function Dt() {
  return (
    lt ||
      ((lt = 1),
      (function (m) {
        (function (l, h) {
          m.exports ? (m.exports = h(l, z(), V(), _())) : h(l, l.Flickity, l.Unipointer, l.fizzyUIUtils);
        })(window, function (h, d, a, s) {
          function n(t) {
            (this.parent = t), this._create();
          }
          (n.prototype = Object.create(a.prototype)),
            (n.prototype._create = function () {
              (this.holder = document.createElement('ol')),
                (this.holder.className = 'flickity-page-dots'),
                (this.dots = []),
                (this.handleClick = this.onClick.bind(this)),
                this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
            }),
            (n.prototype.activate = function () {
              this.setDots(),
                this.holder.addEventListener('click', this.handleClick),
                this.bindStartEvent(this.holder),
                this.parent.element.appendChild(this.holder);
            }),
            (n.prototype.deactivate = function () {
              this.holder.removeEventListener('click', this.handleClick),
                this.unbindStartEvent(this.holder),
                this.parent.element.removeChild(this.holder);
            }),
            (n.prototype.setDots = function () {
              var t = this.parent.slides.length - this.dots.length;
              t > 0 ? this.addDots(t) : t < 0 && this.removeDots(-t);
            }),
            (n.prototype.addDots = function (t) {
              for (
                var e = document.createDocumentFragment(), r = [], c = this.dots.length, g = c + t, f = c;
                f < g;
                f++
              ) {
                var S = document.createElement('li');
                (S.className = 'dot'), S.setAttribute('aria-label', 'Page dot ' + (f + 1)), e.appendChild(S), r.push(S);
              }
              this.holder.appendChild(e), (this.dots = this.dots.concat(r));
            }),
            (n.prototype.removeDots = function (t) {
              var e = this.dots.splice(this.dots.length - t, t);
              e.forEach(function (r) {
                this.holder.removeChild(r);
              }, this);
            }),
            (n.prototype.updateSelected = function () {
              this.selectedDot &&
                ((this.selectedDot.className = 'dot'), this.selectedDot.removeAttribute('aria-current')),
                this.dots.length &&
                  ((this.selectedDot = this.dots[this.parent.selectedIndex]),
                  (this.selectedDot.className = 'dot is-selected'),
                  this.selectedDot.setAttribute('aria-current', 'step'));
            }),
            (n.prototype.onTap = n.prototype.onClick =
              function (t) {
                var e = t.target;
                if (e.nodeName == 'LI') {
                  this.parent.uiChange();
                  var r = this.dots.indexOf(e);
                  this.parent.select(r);
                }
              }),
            (n.prototype.destroy = function () {
              this.deactivate(), this.allOff();
            }),
            (d.PageDots = n),
            s.extend(d.defaults, {pageDots: !0}),
            d.createMethods.push('_createPageDots');
          var o = d.prototype;
          return (
            (o._createPageDots = function () {
              this.options.pageDots &&
                ((this.pageDots = new n(this)),
                this.on('activate', this.activatePageDots),
                this.on('select', this.updateSelectedPageDots),
                this.on('cellChange', this.updatePageDots),
                this.on('resize', this.updatePageDots),
                this.on('deactivate', this.deactivatePageDots));
            }),
            (o.activatePageDots = function () {
              this.pageDots.activate();
            }),
            (o.updateSelectedPageDots = function () {
              this.pageDots.updateSelected();
            }),
            (o.updatePageDots = function () {
              this.pageDots.setDots();
            }),
            (o.deactivatePageDots = function () {
              this.pageDots.deactivate();
            }),
            (d.PageDots = n),
            d
          );
        });
      })(O)),
    O.exports
  );
}
var N = {exports: {}},
  ct;
function Pt() {
  return (
    ct ||
      ((ct = 1),
      (function (m) {
        (function (l, h) {
          m.exports ? (m.exports = h(G(), _(), z())) : h(l.EvEmitter, l.fizzyUIUtils, l.Flickity);
        })(window, function (h, d, a) {
          function s(o) {
            (this.parent = o),
              (this.state = 'stopped'),
              (this.onVisibilityChange = this.visibilityChange.bind(this)),
              (this.onVisibilityPlay = this.visibilityPlay.bind(this));
          }
          (s.prototype = Object.create(h.prototype)),
            (s.prototype.play = function () {
              if (this.state != 'playing') {
                var o = document.hidden;
                if (o) {
                  document.addEventListener('visibilitychange', this.onVisibilityPlay);
                  return;
                }
                (this.state = 'playing'),
                  document.addEventListener('visibilitychange', this.onVisibilityChange),
                  this.tick();
              }
            }),
            (s.prototype.tick = function () {
              if (this.state == 'playing') {
                var o = this.parent.options.autoPlay;
                o = typeof o == 'number' ? o : 3e3;
                var t = this;
                this.clear(),
                  (this.timeout = setTimeout(function () {
                    t.parent.next(!0), t.tick();
                  }, o));
              }
            }),
            (s.prototype.stop = function () {
              (this.state = 'stopped'),
                this.clear(),
                document.removeEventListener('visibilitychange', this.onVisibilityChange);
            }),
            (s.prototype.clear = function () {
              clearTimeout(this.timeout);
            }),
            (s.prototype.pause = function () {
              this.state == 'playing' && ((this.state = 'paused'), this.clear());
            }),
            (s.prototype.unpause = function () {
              this.state == 'paused' && this.play();
            }),
            (s.prototype.visibilityChange = function () {
              var o = document.hidden;
              this[o ? 'pause' : 'unpause']();
            }),
            (s.prototype.visibilityPlay = function () {
              this.play(), document.removeEventListener('visibilitychange', this.onVisibilityPlay);
            }),
            d.extend(a.defaults, {pauseAutoPlayOnHover: !0}),
            a.createMethods.push('_createPlayer');
          var n = a.prototype;
          return (
            (n._createPlayer = function () {
              (this.player = new s(this)),
                this.on('activate', this.activatePlayer),
                this.on('uiChange', this.stopPlayer),
                this.on('pointerDown', this.stopPlayer),
                this.on('deactivate', this.deactivatePlayer);
            }),
            (n.activatePlayer = function () {
              this.options.autoPlay && (this.player.play(), this.element.addEventListener('mouseenter', this));
            }),
            (n.playPlayer = function () {
              this.player.play();
            }),
            (n.stopPlayer = function () {
              this.player.stop();
            }),
            (n.pausePlayer = function () {
              this.player.pause();
            }),
            (n.unpausePlayer = function () {
              this.player.unpause();
            }),
            (n.deactivatePlayer = function () {
              this.player.stop(), this.element.removeEventListener('mouseenter', this);
            }),
            (n.onmouseenter = function () {
              this.options.pauseAutoPlayOnHover &&
                (this.player.pause(), this.element.addEventListener('mouseleave', this));
            }),
            (n.onmouseleave = function () {
              this.player.unpause(), this.element.removeEventListener('mouseleave', this);
            }),
            (a.Player = s),
            a
          );
        });
      })(N)),
    N.exports
  );
}
var H = {exports: {}},
  ut;
function _t() {
  return (
    ut ||
      ((ut = 1),
      (function (m) {
        (function (l, h) {
          m.exports ? (m.exports = h(l, z(), _())) : h(l, l.Flickity, l.fizzyUIUtils);
        })(window, function (h, d, a) {
          function s(o) {
            var t = document.createDocumentFragment();
            return (
              o.forEach(function (e) {
                t.appendChild(e.element);
              }),
              t
            );
          }
          var n = d.prototype;
          return (
            (n.insert = function (o, t) {
              var e = this._makeCells(o);
              if (!(!e || !e.length)) {
                var r = this.cells.length;
                t = t === void 0 ? r : t;
                var c = s(e),
                  g = t == r;
                if (g) this.slider.appendChild(c);
                else {
                  var f = this.cells[t].element;
                  this.slider.insertBefore(c, f);
                }
                if (t === 0) this.cells = e.concat(this.cells);
                else if (g) this.cells = this.cells.concat(e);
                else {
                  var S = this.cells.splice(t, r - t);
                  this.cells = this.cells.concat(e).concat(S);
                }
                this._sizeCells(e), this.cellChange(t, !0);
              }
            }),
            (n.append = function (o) {
              this.insert(o, this.cells.length);
            }),
            (n.prepend = function (o) {
              this.insert(o, 0);
            }),
            (n.remove = function (o) {
              var t = this.getCells(o);
              if (!(!t || !t.length)) {
                var e = this.cells.length - 1;
                t.forEach(function (r) {
                  r.remove();
                  var c = this.cells.indexOf(r);
                  (e = Math.min(c, e)), a.removeFrom(this.cells, r);
                }, this),
                  this.cellChange(e, !0);
              }
            }),
            (n.cellSizeChange = function (o) {
              var t = this.getCell(o);
              if (t) {
                t.getSize();
                var e = this.cells.indexOf(t);
                this.cellChange(e);
              }
            }),
            (n.cellChange = function (o, t) {
              var e = this.selectedElement;
              this._positionCells(o), this._getWrapShiftCells(), this.setGallerySize();
              var r = this.getCell(e);
              r && (this.selectedIndex = this.getCellSlideIndex(r)),
                (this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex)),
                this.emitEvent('cellChange', [o]),
                this.select(this.selectedIndex),
                t && this.positionSliderAtSelected();
            }),
            d
          );
        });
      })(H)),
    H.exports
  );
}
var X = {exports: {}},
  dt;
function zt() {
  return (
    dt ||
      ((dt = 1),
      (function (m) {
        (function (l, h) {
          m.exports ? (m.exports = h(l, z(), _())) : h(l, l.Flickity, l.fizzyUIUtils);
        })(window, function (h, d, a) {
          d.createMethods.push('_createLazyload');
          var s = d.prototype;
          (s._createLazyload = function () {
            this.on('select', this.lazyLoad);
          }),
            (s.lazyLoad = function () {
              var t = this.options.lazyLoad;
              if (t) {
                var e = typeof t == 'number' ? t : 0,
                  r = this.getAdjacentCellElements(e),
                  c = [];
                r.forEach(function (g) {
                  var f = n(g);
                  c = c.concat(f);
                }),
                  c.forEach(function (g) {
                    new o(g, this);
                  }, this);
              }
            });
          function n(t) {
            if (t.nodeName == 'IMG') {
              var e = t.getAttribute('data-flickity-lazyload'),
                r = t.getAttribute('data-flickity-lazyload-src'),
                c = t.getAttribute('data-flickity-lazyload-srcset');
              if (e || r || c) return [t];
            }
            var g = 'img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]',
              f = t.querySelectorAll(g);
            return a.makeArray(f);
          }
          function o(t, e) {
            (this.img = t), (this.flickity = e), this.load();
          }
          return (
            (o.prototype.handleEvent = a.handleEvent),
            (o.prototype.load = function () {
              this.img.addEventListener('load', this), this.img.addEventListener('error', this);
              var t =
                  this.img.getAttribute('data-flickity-lazyload') ||
                  this.img.getAttribute('data-flickity-lazyload-src'),
                e = this.img.getAttribute('data-flickity-lazyload-srcset');
              (this.img.src = t),
                e && this.img.setAttribute('srcset', e),
                this.img.removeAttribute('data-flickity-lazyload'),
                this.img.removeAttribute('data-flickity-lazyload-src'),
                this.img.removeAttribute('data-flickity-lazyload-srcset');
            }),
            (o.prototype.onload = function (t) {
              this.complete(t, 'flickity-lazyloaded');
            }),
            (o.prototype.onerror = function (t) {
              this.complete(t, 'flickity-lazyerror');
            }),
            (o.prototype.complete = function (t, e) {
              this.img.removeEventListener('load', this), this.img.removeEventListener('error', this);
              var r = this.flickity.getParentCell(this.img),
                c = r && r.element;
              this.flickity.cellSizeChange(c), this.img.classList.add(e), this.flickity.dispatchEvent('lazyLoad', t, c);
            }),
            (d.LazyLoader = o),
            d
          );
        });
      })(X)),
    X.exports
  );
}
/*!
 * Flickity v2.3.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2021 Metafizzy
 */ var ft;
function At() {
  return (
    ft ||
      ((ft = 1),
      (function (m) {
        (function (l, h) {
          m.exports && (m.exports = h(z(), bt(), Ct(), Dt(), Pt(), _t(), zt()));
        })(window, function (h) {
          return h;
        });
      })(L)),
    L.exports
  );
}
var Lt = At();
const It = vt(Lt);
export {It as F, _ as a, At as r};
